export default "__VITE_ASSET__Cxor2dVd__"